import React, { useEffect, useState } from "react";

import Navbar from "components/Navbar.js";
import Countdown from "react-countdown";
import ProfilePageHeader from "components/Headers/ProfilePageHeader.js";

import Footer from "components/Footer.js";
import { Container, Row, Col } from "reactstrap";
import { apiUrl } from "../constants";
import { apiToken } from "../constants";
function QRRedirect({
  match: {
    params: { id },
  },
}) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const getDelegateData = () => {
    setLoading(true);
    fetch(`${apiUrl}/getDelegateData/${id}`, {
      method: "get",
      headers: new Headers({
        Authorization: apiToken,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        const [row] = (data && data.rows) || [{}];
        setData(row);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };
  useEffect(() => {
    getDelegateData();
  }, []);

  return (
    <>
      <Navbar />
      {data.id ? (
        <>
          <ProfilePageHeader title={`${data.firstName} ${data.lastName}`} bgColor="#fff" />
          <div className="section profile-content" style={{ padding: 0, background: "#fff" }}>
            <Container>
              <Row className="justify-content-center">
                <Col lg={12} xs={12} className="text-center text-white p-5 m-5">
                  <h2 className="text-center text-dark text-700 my-0 align-self-center mr-3 text-uppercase">
                    {data.title}
                  </h2>
                  <h2 className="text-center text-dark text-700 my-0 align-self-center mr-3 text-uppercase">
                    {data.company}, {data.country}
                  </h2>

                  <h4 className="text-center text-dark text-700 mt-2 align-self-center mr-3 text-uppercase">
                    <a
                      style={{ color: "#5ab02f", wordBreak: "break-word" }}
                      href={`mailto:${data.email}`}
                    >
                      {data.email}
                    </a>
                  </h4>
                  {data.phone && (
                    <h4>
                      <a style={{ color: "#5ab02f" }} href={`tel:${data.phone}`}>
                        {data.phone}
                      </a>
                    </h4>
                  )}
                </Col>
              </Row>
            </Container>
          </div>
        </>
      ) : (
        <ProfilePageHeader title={loading ? "LOADING ...." : `No Data`} bgColor="#fff" />
      )}
      <Footer />
    </>
  );
}

export default QRRedirect;
